import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { ArticlesService } from './articles.service';

@Injectable({
  providedIn: 'root',
})
export class ArticlesResolver implements Resolve<any> {
  constructor(private _articleService: ArticlesService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    // Fork join multiple API endpoint calls to wait all of them to finish

    const search = route.queryParamMap.get('s') ?? undefined;
    console.log(
      '🚀 ~ ArticlesResolver ~ search:',
      route.paramMap.get('category'),
    );
    return combineLatest([
      //this._navigationService.get(),
      this._articleService.getPage(),
      this._articleService.getCategory(
        'slug',
        route.paramMap.get('category') || '',
      ),
      this._articleService.getAll(
        'slug',
        route.paramMap.get('category') || '',
        parseInt(route.queryParamMap.get('page')!) || 0,
        24,
        'publishDate:desc',
        search,
      ),
    ]);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ArticleResolver implements Resolve<boolean> {
  constructor(private _articleService: ArticlesService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    let slug = route.paramMap.get('slug') || '';
    slug = slug.split('-p').pop() || '';
    console.log('🚀 ~ ArticleResolver ~ slug:', slug);

    return this._articleService.get('slug', slug);
  }
}
